<template>
  <el-dialog
    title="Персональный отчет по оценке"
    :visible.sync="show"
    top="2vh"
    width="90%"
    :close-on-click-modal="false"
  >
    <div>
      <my-evaluation-result
        ref="evaluationResult"
        :userId="user ? user.id : null"
        :evaluationId="evaluationId"
        :teacher="true"
      ></my-evaluation-result>
    </div>
  </el-dialog>
</template>

<script>
import MyEvaluationResult from "@/modules/evaluation/components/myEvaluation/MyEvaluationResult.vue";

export default {
  name: "evaluate-result-dialog",
  components: {MyEvaluationResult},
  data() {
    return {
      show: false,
      user: null,
      evaluationId: null,
      evaluatee: {},
    }
  },
  methods: {
    async open(user, evaluationId) {
      this.user = user;
      this.evaluationId = evaluationId;
      this.show = true;

      this.$nextTick(() => {
        this.$refs.evaluationResult?.loadEvaluationResult();
      });
    },
  }
}
</script>

<style>

</style>